import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=f130db80"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f130db80')) {
      api.createRecord('f130db80', component.options)
    } else {
      api.reload('f130db80', component.options)
    }
    module.hot.accept("./newsDetail.vue?vue&type=template&id=f130db80", function () {
      api.rerender('f130db80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherMatch/newsDetail.vue"
export default component.exports